import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Trash2, X, RotateCcw, Trash } from "lucide-react";

export default function SelectionBar({
  count,
  onClear,
  actions = [],
  noun = "item",
}) {
  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", damping: 22 }}
          className="fixed bottom-5 left-1/2 -translate-x-1/2 z-40 bg-slate-900 text-white shadow-2xl rounded-full pl-5 pr-2 py-2 flex items-center gap-3"
          style={{ minWidth: 360 }}
        >
          <span className="text-sm font-medium">
            <span className="text-amber-300 font-semibold">{count}</span>{" "}
            {noun}
            {count !== 1 ? "s" : ""} selected
          </span>
          <div className="w-px h-6 bg-white/15" />
          <div className="flex items-center gap-1">
            {actions.map((a) => (
              <button
                key={a.label}
                onClick={a.onClick}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${
                  a.variant === "danger"
                    ? "bg-red-500/15 text-red-300 hover:bg-red-500/25"
                    : a.variant === "success"
                    ? "bg-emerald-500/15 text-emerald-300 hover:bg-emerald-500/25"
                    : "bg-white/10 text-white hover:bg-white/20"
                }`}
              >
                {a.icon && <a.icon className="w-3.5 h-3.5" />}
                {a.label}
              </button>
            ))}
          </div>
          <button
            onClick={onClear}
            className="ml-1 inline-flex items-center justify-center w-8 h-8 rounded-full text-white/60 hover:text-white hover:bg-white/10"
            title="Clear selection"
          >
            <X className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export { Trash2, RotateCcw, Trash };
